import { Enrollment } from "@api/types/enrollments";
import React, { FC, useRef } from "react";

import Button from "@components/Button";

const CourseCertificateDownload: FC<{ enrollment: Enrollment }> = ({ enrollment }) => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  return (
    <>
      <div className="CourseCertificateDownload">
        {enrollment.complete ? (
          <Button theme="secondary" onClick={() => linkRef.current.click()}>
            <a
              ref={linkRef}
              onClick={(e) => {
                e.stopPropagation();
              }}
              href={enrollment.certificateUrl}
              target="_blank">
              Get Certificate
            </a>
          </Button>
        ) : (
          <Button disabled={true}>Get Certificate</Button>
        )}
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .CourseCertificateDownload {
          }

          a {
            text-decoration: none;
            color: white;
          }
        `}
      </style>
    </>
  );
};

export default CourseCertificateDownload;
